export default __webpack_public_path__ + "static/media/home.eec4ce67.svg";